/* Forspec hero buy box (sections/fsp-hero.liquid). Same cart flow as ppf.js,
   plus a variant chooser: the size cards set the variant the buttons add. */
(function () {
  function init(root) {
    if (root.dataset.fspReady) return;
    root.dataset.fspReady = '1';

    var cfgEl = root.querySelector('[data-ppf-config]');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = {}; }

    var toastEl = root.querySelector('[data-ppf-toast]');
    var toastMsg = root.querySelector('[data-ppf-toast-msg]');
    var toastTimer = null;

    function toast(msg) {
      if (!toastEl || !msg) return;
      if (toastMsg) toastMsg.textContent = msg;
      toastEl.classList.add('is-visible');
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3400);
    }

    var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var fmt = cfg.moneyFormat || '${{amount}}';
    var qty = 1;

    function money(cents) {
      var amount = cents / 100;
      var withCents = amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
      var noCents = Math.round(amount).toString().replace(/\d(?=(\d{3})+$)/g, '$&,');
      return fmt
        .replace('{{amount}}', withCents)
        .replace('{{amount_with_comma_separator}}', withCents.replace('.', ','))
        .replace('{{amount_no_decimals}}', noCents)
        .replace('{{amount_no_decimals_with_comma_separator}}', noCents);
    }

    // Coverage per pack, from the TDS figure in calc_coverage (e.g. "8-10 m²"
    // for a "20kg kit"). Only per-kit figures at 2 coats are used; per-litre
    // rates and other coat counts are skipped rather than converted.
    var cov = cfg.coverage || {};
    var covRange = null;
    var kitSize = 0;
    (function () {
      var text = String(cov.text || '');
      if (!text || !cov.label || parseInt(cov.coats, 10) !== 2) return;
      if (/\/|coat/i.test(text)) return;
      var m = text.match(/(\d+(?:\.\d+)?)\s*(?:-|–|to)\s*(\d+(?:\.\d+)?)/) || text.match(/(\d+(?:\.\d+)?)/);
      var k = String(cov.kit || '').match(/(\d+(?:\.\d+)?)/);
      if (!m || !k) return;
      kitSize = parseFloat(k[1]);
      covRange = [parseFloat(m[1]), parseFloat(m[2] || m[1])];
    })();

    function currentPack() {
      var v = (cfg.variants || []).filter(function (x) { return x.id === cfg.variantId; })[0];
      return v && parseFloat(v.pack) > 0 ? parseFloat(v.pack) : kitSize;
    }

    function fmtArea(n) {
      return (Math.round(n * 10) / 10).toString();
    }

    function paintCoverage() {
      var els = root.querySelectorAll('[data-fsp-coverage]');
      if (!els.length) return;
      if (!covRange || !kitSize) { els.forEach(function (el) { el.hidden = true; }); return; }
      var scale = (currentPack() / kitSize) * qty;
      var lo = covRange[0] * scale, hi = covRange[1] * scale;
      var area = lo === hi ? fmtArea(lo) : fmtArea(lo) + '–' + fmtArea(hi);
      els.forEach(function (el) {
        el.textContent = cov.label.replace('[area]', area);
        el.hidden = false;
      });
    }

    function paint() {
      root.querySelectorAll('[data-ppf-qty-val]').forEach(function (el) { el.textContent = qty; });
      root.querySelectorAll('[data-ppf-line]').forEach(function (el) { el.textContent = money((cfg.price || 0) * qty); });
      paintCoverage();
    }

    root.querySelectorAll('[data-ppf-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-ppf-qty'), 10) || 0;
        qty = Math.max(1, Math.min(99, qty + step));
        paint();
      });
    });

    var atcBtns = Array.prototype.slice.call(root.querySelectorAll('[data-ppf-atc]'));

    function selectVariant(id) {
      var v = (cfg.variants || []).filter(function (x) { return x.id === id; })[0];
      if (!v) return;
      cfg.variantId = v.id;
      cfg.price = v.price;
      cfg.available = v.available;
      root.querySelectorAll('[data-fsp-variant]').forEach(function (b) {
        var on = parseInt(b.getAttribute('data-fsp-variant'), 10) === v.id;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-ppf-total], [data-fsp-price]').forEach(function (el) { el.textContent = money(v.price); });
      // Price in the top card (theme price-list markup).
      root.querySelectorAll('.fsp-top sale-price').forEach(function (el) {
        var sr = el.querySelector('.sr-only');
        el.textContent = money(v.price);
        if (sr) el.insertBefore(sr, el.firstChild);
      });
      root.querySelectorAll('.fsp-top compare-at-price').forEach(function (el) {
        var sr = el.querySelector('.sr-only');
        if (v.compare > v.price) {
          el.textContent = money(v.compare);
          if (sr) el.insertBefore(sr, el.firstChild);
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });
      root.querySelectorAll('[data-fsp-vtitle]').forEach(function (el) { el.textContent = v.title; });
      atcBtns.forEach(function (b) {
        b.disabled = !v.available;
        var lbl = b.querySelector('[data-ppf-atc-label]');
        if (lbl) lbl.textContent = v.available ? (cfg.addLabel || 'Add to cart') : (cfg.soldOutLabel || 'Sold out');
        var ic = b.querySelector('[data-fsp-cart-icon]');
        if (ic) ic.style.display = v.available ? '' : 'none';
      });
      paint();
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
      // The coverage calculator (product-overview-row) follows this event.
      document.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: v } }));
    }

    root.querySelectorAll('[data-fsp-variant]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectVariant(parseInt(btn.getAttribute('data-fsp-variant'), 10));
      });
    });

    function afterAdd() {
      fetch(routeRoot + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true, detail: { baseEvent: 'fsp:add', cart: cart }
          }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var drawer = document.getElementById('cart-drawer') || document.querySelector('cart-drawer, .cart-drawer');
          if (drawer && typeof drawer.show === 'function') drawer.show();
          else if (drawer && typeof drawer.open === 'function') drawer.open();
          else document.documentElement.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
        })
        .catch(function () {});
    }

    function post(items, btns) {
      btns.forEach(function (b) { b.disabled = true; });
      return fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (res) { if (!r.ok) throw res; return res; }); })
        .then(function () {
          afterAdd();
          btns.forEach(function (b) {
            var lbl = b.querySelector('[data-ppf-atc-label]');
            if (!lbl) return;
            if (b.dataset.ppfLabel === undefined) b.dataset.ppfLabel = lbl.textContent;
            lbl.textContent = cfg.addedLabel || 'Added';
          });
          setTimeout(function () {
            btns.forEach(function (b) {
              var lbl = b.querySelector('[data-ppf-atc-label]');
              if (lbl && b.dataset.ppfLabel) lbl.textContent = b.dataset.ppfLabel;
              delete b.dataset.ppfLabel;
            });
          }, 2200);
        })
        .catch(function (err) {
          toast((err && (err.description || err.message)) || cfg.cartErrorLabel || 'Sorry, that could not be added to your cart.');
        })
        .then(function () {
          btns.forEach(function (b) {
            b.disabled = atcBtns.indexOf(b) > -1 ? cfg.available === false : false;
          });
        });
    }

    atcBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (!cfg.variantId || cfg.available === false) return;
        post([{ id: cfg.variantId, quantity: qty }], atcBtns);
      });
    });

    root.querySelectorAll('[data-ppf-add-one]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = parseInt(btn.getAttribute('data-ppf-add-one'), 10);
        if (!id) return;
        post([{ id: id, quantity: 1 }], [btn]);
      });
    });

    var sticky = root.querySelector('[data-ppf-sticky]');
    if (sticky) {
      var footerVisible = false;
      var onScroll = function () {
        var past = (window.scrollY || window.pageYOffset || 0) > 600;
        if (past && !footerVisible) sticky.classList.add('is-visible');
        else sticky.classList.remove('is-visible');
      };
      var footer = document.querySelector('.shopify-section--footer, footer');
      if (footer && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          footerVisible = entries[0].isIntersecting;
          onScroll();
        }, { rootMargin: '0px 0px 80px 0px' }).observe(footer);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    paint();
  }

  function boot() { document.querySelectorAll('[data-fsp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
